/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRotateLeft: {
  name: 'arrow-rotate-left';
  data: string;
} = {
  name: 'arrow-rotate-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a1 1 0 0 1 1 1v1.244A9.15 9.15 0 0 1 12 3a9 9 0 1 1-9 9 1 1 0 1 1 2 0 7 7 0 1 0 7-7 7.151 7.151 0 0 0-4.957 2H9a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
